
import axiosServices from './request';

const BookCenter = axiosServices('book');

export default {
  /** 查询是否是新用户 */
  getUserNewState: BookCenter('get', 'resourcePage/getUserNewState'),
  /** 添加是否新用户记录 */
  addNewUserRecord: BookCenter('post', 'resourcePage/addNewUserRecord'),
  /** 客户端-根据rays码id查资源页基本配置 */
  getResourcePageByBookGroupId4Wechat: data => BookCenter('get', 'resourcePage/getResourcePageByBookGroupId4Wechat')(data).then(res => {
    if(res && res.navigationList && Array.isArray(res.navigationList)) {
      // 前端过滤书友互助
      res.navigationList = res.navigationList.filter(e => e.navigationName !== '书友互助');
    }
    return res;
  }),
  /** 查询loading页、引导页组件 */
  listMiddlePage4Wechat: data => BookCenter('get', 'middlePage/listMiddlePage4Wechat')(data).then(res => res),
  /** 根据页面id查资源页栏目及资源 */
  getColumnAndServeListByPageId4Wechat: BookCenter('get', 'resourcePage/getColumnAndServeListByPageId4Wechat'),

  /** getColumnAndServeListByPageId4Wechat 接口拆分 start **/
  // 配置类型
  getColumnTypeByPageId4Wechat: BookCenter('get', 'resourcePage/getColumnTypeByPageId4Wechat'),

  // 类型获取配置内容
  getColumnAndServeListByPageId4WechatV2: BookCenter('get', 'resourcePage/getColumnAndServeListByPageId4WechatV2'),

  /** getColumnAndServeListByPageId4Wechat 接口拆分 end **/

  /** 查栏目资源 */
  listPageResourcePageItem: BookCenter('get', 'resourcePage/listPageResourcePageItem'),
  /** 根据书的3个id查资源页基本配置 */
  getResourcePageByBookId4Wechat: data => BookCenter('get', 'resourcePage/getResourcePageByBookId4Wechat')(data).then(res => {
    if(Array.isArray(res.navigationList)) {
      // 前端过滤书友互助
      res.navigationList = res.navigationList.filter(e => e.navigationName !== '书友互助');
    }
    return res;
  }),

  /** 根据bookGroupId获取书刊信息 */
  getBookGroupInfo4Wechat: BookCenter('get', 'bookGroup/getBookGroupInfo4Wechat'),

  /** bookGroupId或sceneId 查码下是否只有一个资源 */
  hasOneResource: BookCenter('get', 'resourcePage/hasOneResource'),

  /**  入参： resourcePageId
   *
   *
   * hasOfficialAccountsTool 为true   就保持原链接跳转
   * */
  hasOfficialAccountsTool: BookCenter('get', 'resourcePage/hasOfficialAccountsTool'),

  /** 根据BookGroupId获取小程序社群码信息 */
  getBookGroupAppletByBookGroupId: BookCenter('get', 'bookGroup/getBookGroupAppletByBookGroupId'),
  /** 获取用户最后一次点击的书（有社群书的取最后一次社群书，没有的取现代纸书） */
  getUserLastBookRe: () => BookCenter('get', 'appletHome/getUserLastBookRe')({ isAllBook: 1 }),
  /** 获取书籍基本信息 (带有权益、资源、社群信息) */
  getUserBookInfoByWechatUserId: BookCenter('get', 'appletHome/getUserBookInfoByWechatUserId'),
  /**答案弹窗 */
  getPopupResourceInfoByBook: BookCenter('get', 'rightsSetting/getPopupResourceInfoByBook'),
  /** 是否是系列书，返回系列书id */
  isSeriesBook: BookCenter('get', 'book/isSeriesBook'),
  /** 根据bookId获取书刊信息 */
  getBaseById: BookCenter('get', 'book/getBaseById'),
  /** 根据权益id和类型获取即享权益项 */
  getRightsSettingRightsNowItemsByType: BookCenter('post', 'rightsSetting/getRightsSettingItemsByTypeListNew'),
  /** 获取书的信息 */
  getBookBaseInfo4Applet: BookCenter('get', 'bookGroup/getBookBaseInfo4Applet'),
  /** 公众号是否关注 */
  getSubscribeQrcodeState: BookCenter('get', 'appletHome/getSubscribeQrcodeState'),
  /** 关注公众号 推送消息的埋点 */
  addSubscribePushRecord: BookCenter('post', 'appletHome/addSubscribePushRecord'),

  /**
   * 答案弹窗相关点击事件埋点
   * ```
    "bookId":5210593,
    "channelId":1404,
    "adviserId": 1404,
    "rightsSettingId": 810,
    "popupType":2, (1 配套资料包  2 线上网课服务 5 背单词小程序)
    "serveId":1871,
    "serveType":"NEWS",
    "recordType":3  （1弹出2点击领取3关闭）
   * ```
  */
  addPopupRecord: BookCenter('post', 'rightsSetting/addPopupRecord'),
  /** 新增足迹埋点
   * recordType: 8出版社书单 (好书推荐)
   */
  footPrintAddClickRecord: BookCenter('post', 'appletRecord/insert'),
  /**系列书埋点 */
  addSeriesBookRecord: BookCenter('post', 'book/addSeriesBookRecord'),
  /**
   * 资讯外链埋点
   * fromId:业务id(咨询ID或券ID);
   * recordType:1点击,2浏览,3使用;
   * typeId:1资讯,2券库,3编辑群,4 社群共读模板群（官方群，第三方群）,5 书单, 6 H5首页未上线的点赞
   * wechatUserId
   */
  addClickRecord: BookCenter('post', 'appletHome/addClickRecord'),
  /** 获取H5首页未上线的点赞 */
  getStayOnlineAppClickCount: BookCenter('get', 'appletHome/getStayOnlineAppClickCount'),
  /**
   * 专项礼包券（新增礼券包领取）
   * - type: 'noHandle' errorCode不为0的情况特殊处理
   */
  createGiftReceive: BookCenter('post', 'giftCouponPackage/createGiftReceive', { type: 'noHandle' }),
  // 专项礼包券（新增礼券包领取）
  createGiftReceiveOld: BookCenter('post', 'giftCouponPackage/createGiftReceive'),
  /** 首页券（一键领取） */
  createGiftReceiveBatch: BookCenter('post', 'giftCouponPackage/createGiftReceiveBatch'),
  /** 根据分类ID或群二维码ID获取微信文章 */
  getGroupNewsMaterialById: BookCenter('get', 'bookGroup/getGroupNewsMaterialById'),
  /**根据学科查系列书书刊列表 */
  getSeriesBookList: BookCenter('get', 'book/getSeriesBookList'),
  /** 获取开启世间食记系列书 */
  getAllBook4OpenFood: BookCenter('get', 'resourcePage/getAllBook4OpenFood'),
  /**查询书刊配置的企业微信码 */
  getWxworkQrcodeInfoByBook4Rays: BookCenter('get', 'bookWxwork/getWxworkQrcodeInfoByBook4Rays'),
  /**
   * 收藏应用
   * - 必填
   * serveId 资讯id Appid ProductId
   * serveName 名称
   * serveType 1资讯, 5PRODUCT, 6APP
   * serveTypeCode 资讯NEWS, ANSWER, ADUIO,... 有什么就传什么
   * serveTypeName 答案、音频...
   * - 非必填
   * linkUrl 只有app product才有
   * pic 应用的图片
   * isDelete 不传默认为0，取消收藏传1。
   */
  collectSomething: BookCenter('post', 'serveCollect/collect'),
  /** 获取getti入口 */
  getBookAndBookGroupRaysApps: BookCenter('get', 'bookGroup/getBookAndBookGroupRaysApps'),
  /** 根据书刊查推荐书单 */
  getRecommendBooklist: BookCenter('get', 'appletHome/getRecommendBooklist'),
  /** 根据资讯id查资讯详情 */
  getAppletNewsById: BookCenter('get', 'appletHome/getAppletNewsById'),
  /** 第三方资源埋点 */
  thirdResourcesAddClickRecord: BookCenter('post', 'appletThirdResources/addClickRecord'),
  /** 获取本书服务评价 */
  getBookScore: BookCenter('get', 'appletBookScore/get'),
  // 新增/修改本书评价
  addBookScore: BookCenter('get', 'appletBookScore/add'),
  /** 本书服务评价 */
  feedback: BookCenter('post', 'appletBookScore/feedback'),
  /** 获取书刊基础信息 */
  getBookBase4Applet: BookCenter('get', 'bookGroup/getBookBase4Applet'),

  /*查书单及书刊列表 */
  getOutBooklistById4Wechat: BookCenter('get', 'appletHome/getOutBooklistById4Wechat'),

  /*查书单及书刊列表 */
  hasCollection: BookCenter('post', 'resourcePage/addCollectRecord'),

  /** 查看订阅状态及是否有答案 */
  getSubscribeState: BookCenter('post', 'appletHome/getSubscribeState'),
  /** 本书服务订阅 */
  answerSubscribe: BookCenter('post', 'appletHome/answerSubscribe'),

  /** 搜索图书 */
  getAdviserBooks4Applet: BookCenter('post', 'book/getAdviserBooks4Applet'),
  // 为你推荐
  getRecommendList: BookCenter('get', 'appletThirdResources/getThirdResourcesByGradeLabel4ResourcePage'),
  /** 获取首页书架列表 */
  listUserBookcaseByWechatUserId: BookCenter('get', 'appletHome/listUserBookcaseByWechatUserId'),
  /** 获取收藏列表 */
  getCollectionList: BookCenter('get', 'serveCollect/getList'),
  /** 删除已读书刊书籍记录 */
  deleteBookcaseRecordByIds: BookCenter('post', 'appletHome/deleteBookcaseRecordByIds'),
  /** 收藏分类列表 */
  getTypeNameAndCount: BookCenter('get', 'serveCollect/getTypeNameAndCountByWechatUserId'),
  /** 全选收藏项 */
  getAllCollect: BookCenter('get', 'serveCollect/getAllCollect'),
  /** 全选接口: 已读书刊 */
  getBookcaseIdListByUser: BookCenter('get', 'appletHome/getBookcaseIdListByUser'),
  /** 批量取消收藏 */
  cancelCollect: BookCenter('post', 'serveCollect/cancelCollect'),
  /** 添加书籍点击记录 */
  addUserBook: BookCenter('post', 'appletHome/addUserBook'),
  /** 添加社群书搜索记录 */
  insertSearchRecord: BookCenter('post', 'appletGroupManage/insertSearchRecord'),
  /**获取足迹列表 */
  getFootPrintList: BookCenter('post', 'appletRecord/listAppletRecord'),
  // 小程序我的足迹埋点
  addFootRecord: BookCenter('post', 'appletRecord/addFootstep'),
  /** 获取足迹筛选目录 */
  getAppletRecordCatalogue: BookCenter('post', 'appletRecord/getAppletRecordCatalogue'),
  /** 我的足迹三十天有数据的时间 */
  listUnreachableDate: BookCenter('get', 'appletRecord/listUnreachableDate'),
  /** 首页banner */
  getBannerByGradeLabel4ResourcePage: BookCenter('get', 'appletHome/getBannerByGradeLabel4ResourcePage'),
  /** 首页-客服老师 */
  getTeacherByGradeLabel4ResourcePage: BookCenter('get', 'weworkTeacher/getTeacherByGradeLabel4ResourcePage'),
  /** 资源广场获取模块列表 */
  getResourceSourceTypeList: BookCenter('get', 'resourcePage/getResourceSourceTypeList'),
  /** 资源广场根据模块搜索 */
  getResource4H5: BookCenter('get', 'appletRecordAggrStatis/getResource4H5'),
  /** 首页-推荐书单 */
  getBooklistByGradeLabel4ResourcePage: BookCenter('get', 'appletHome/getBooklistByGradeLabel4ResourcePage'),
  /** 首页-课程推荐 */
  listCourseByUser: BookCenter('get', 'resourcePage/listCourseByUser'),
  /** 首页工具列表 */
  getToolListByUser: BookCenter('get', 'resourcePage/getToolListByUser'),
  /**小程序我的-消息通知：四种类型消息列表 */
  getNotify4Type: BookCenter('get', 'cultivateNotify/getNotify4Type'),
  /** 最近搜索的书籍 */
  getLatestSearchList: BookCenter('get', 'search/getUserSearchList4H5'),
  /** 热门搜索书籍 */
  getHotBookList: BookCenter('get', 'search/getHotBookList4H5'),
  /** 创建搜索记录 */
  createSearchRecord: BookCenter('post', 'search/createSearchRecord4H5'),
  /** 删除搜索记录 */
  deleteUserSearchList4H5: BookCenter('get', 'search/deleteUserSearchList4H5'),
  /** 本书服务取消书籍收藏 */
  cancelAnswerSubscribe: BookCenter('post', 'appletHome/cancelAnswerSubscribe'),
  /** 查找读书笔记 */
  getBookCardId4Book: BookCenter('get', 'rightsSetting/getBookCardId4Book'),

  /**获取馆配书单 */
  getLibraryBooklistByBookId: BookCenter('get', 'appletHome/getLibraryBooklistByBookId'),

  /** 获取馆配书单下面的书籍列表 */
  listPageLibraryBookByBookId: BookCenter('get', 'appletHome/listPageLibraryBookByBookId'),

  /** 客户端-查询弹窗二维码 */
  getPopupQrcode4Wechat: BookCenter('get', 'resourcePage/getPopupQrcode4Wechat'),
  /** 查询书的标签对应的年级段 */
  getBookGradeLabel: BookCenter('get', 'bookAdviser/getBookGradeLabel'),
  /** 用户扫描授权码之后验证授权码 */
  checkSceneAuthCode: BookCenter('post', 'bookAuthCode/checkSceneAuthCode'),

  /** 获取是否开启商品推荐 */
  getOpenRecommend: BookCenter('get', 'bookAdviser/getOpenRecommend'),

  /** 查询书刊推荐资源 */
  getBookRecommendServe: BookCenter('get', 'resourcePage/getBookRecommendServe'),
  /** 获取教辅书对应的年级标签 */
  getBookGradeLabelId: BookCenter('get', 'bookAdviser/getBookGradeLabelId'),

  //获取分享配置
  getShareConfig4Wechat: BookCenter('get', 'resourcePage/getShareConfig4Wechat'),

  //获取斗罗落地页列表
  getServerList4Wechat: BookCenter('get', 'resourcePage/getServerList4Wechat'),

  // 二维码下面有几个菜单
  getNavigationCount: BookCenter('get', 'resourcePage/getNavigationCount'),

  // 客户端获取新版组件详细内容
  getFolderItemList: BookCenter('get', 'resourcePage/getFolderItemList'),
  // 获取是否开启教辅大礼包
  getOpenGiftBag: BookCenter('get', 'bookAdviser/getOpenGiftBag'),

  // 魔方书刊
  listMoFangBook: BookCenter('get', 'book/listMoFangBook'),

  // 魔方二维码
  listMoFangScene: BookCenter('get', 'book/getMoFangScene'),

  // 魔方新华书店
  listMoFangBookStore: BookCenter('get', 'book/listBookStore'),

  // 版权保护--查询版权书刊基础信息
  getInfoByBook4Wechat: BookCenter('post', 'bookAuthInfo/getInfoByBook4Wechat'),

  // 查询版权书扫码的状态以及可授权的次数
  checkSceneAuthCodeUseType: BookCenter('post', 'bookAuthCode/checkSceneAuthCodeUseType'),
  // 书是否被激活
  checkIsHaveAuthV1: BookCenter('post', 'bookAuthUser/checkIsHaveAuthV1'),

  // 查看是否进小程序查看资源
  getEnterApplet4Wechat: BookCenter('get', 'bookAdviser/getEnterApplet4Wechat'),

  // 获取推荐资源-demo
  getRecommendResource: BookCenter('get', 'resourcePage/getRecommendResource'),
  // 添加二维码弹窗访问记录
  addResourcePagePopupRecord: BookCenter('post', 'resourcePage/addResourcePagePopupRecord'),
  // 是否使用https
  isUseHttps: BookCenter('get', 'resourcePage/checkWhcbsBookOutLinkUseHttps')
};
